import React from 'react';

import { DynamicProduct } from '../../../DynamicProduct';
import { availableProductPrivatePensionConstant } from '../../../DynamicProduct/components/Product/products/PrivatePension/constants';

export const PrivatePensionContent: React.FC = () => (
  <DynamicProduct infoGetter={() => ({})} product={availableProductPrivatePensionConstant} />
);
